import React from 'react';
import './Card.css';
import StatusBadge from './StatusBadge';

const FailureRateCard = ({ 
  title = "High failure rate",
  value = "Session replay",
  changePercentage = "+xx%",
  comparisonPeriod = "vs. previous day",
  description = "Session replay module failure rate has inceased by xx% since yesterday, to xx%."
}) => {
  return (
    <div className="empty-card">
      <div className="metric-header">
        <h2>{title}</h2>
        <StatusBadge status="monitor" label="To monitor" />
      </div>
      <div className="metric-value">{value}</div>
      <div className="metric-comparison">
        <span className="percentage-increase">{changePercentage}</span>
        <span className="comparison-period">{comparisonPeriod}</span>
      </div>
      <p className="metric-description">{description}</p>
    </div>
  );
};

export default FailureRateCard; 